import axios from "axios"
import { useEffect, useState } from "react"
import { Button, Form, Modal } from "react-bootstrap"
import { useMutation } from "react-query"
import { DEV_SERVER } from "../../../constants/urls"
import { userSignal } from "../../../signal/userSignal"
import { toast } from "react-toastify"
import Select from "react-select"
import * as moment from "moment"


export default function AddEditOffer(props) {

    const [offer, setOffer] = useState({
        name: "",
        banner: "",
        description: "",
        startTime: 0,
        endTime: 0,
        isActive: true
    })
    const [edit, setEdit] = useState(false)

    const imageUploadMutation = useMutation((data) => axios.post(`${DEV_SERVER}/auth/v2/uploadMedia`, data, {
        headers: {
            'Content-Type': 'multipart/form-data',
            "Authorization": `Bearer ${userSignal.value?.token}`
        },
        timeout: 300000, // 5 minutes timeout for large file uploads
        maxContentLength: Infinity,
        maxBodyLength: Infinity
    }), {
        onSuccess: (data) => {
            if (data?.data?.status) {
                if (data?.data?.data?.length > 0) {
                    let media = data?.data?.data[0]
                    setOffer({ ...offer, banner: media?.url })
                } else {
                    toast.error("Something went wrong")
                }
            } else {
                toast.error(data.data.message)
            }
        },
        onError: (error) => {
            console.log("error ", error)
            if (error.response?.data?.message) {
                toast.error(error.response.data.message)
            } else {
                toast.error(error.message)
            }
        }
    })

    const handleImageUpload = (e) => {
        let data = new FormData();
        for (let i = 0; i < e.target.files?.length; i++) {
            data.append("media", e.target.files[i])
        }
        imageUploadMutation.mutate(data)
    }

    const addOfferMutation = useMutation((body) => axios.post(`${DEV_SERVER}/offer/v2`, body, {
        headers: {
            Authorization: `Bearer ${userSignal.value?.token}`
        }
    }), {
        onSuccess: (data) => {
            if (data.data.status) {
                toast.success("Offer added successfully")
                props?.refetchOffers()
                props?.close()
            } else {
                toast.error(data.data.message)
            }
        },
        onError: (error) => {
            console.log("error ", error)
            if (error.response?.data?.message) {
                toast.error(error.response.data.message)
            } else {
                toast.error(error.message)
            }
        }
    })

    const editOfferMutation = useMutation((data) => axios.put(`${DEV_SERVER}/offer/v2/${data.id}`, data.body, {
        headers: {
            Authorization: `Bearer ${userSignal.value?.token}`
        }
    }), {
        onSuccess: (data) => {
            if (data.data.status) {

                toast.success("Offer updated successfully")
                props?.refetchOffers()
                props?.close()
            } else {
                toast.error(data.data.message)
            }
        },

        onError: (error) => {
            console.log("error ", error)
            if (error.response?.data?.message) {
                toast.error(error.response.data.message)
            } else {
                toast.error(error.message)
            }
        }
    })

    const handleSubmit = () => {
        if (offer?.name === "") {
            toast.error("Name is required")
            return
        }

        if (offer?.banner === "") {
            toast.error("Banner is required")
            return
        }

        if (offer?.startTime === 0) {
            toast.error("Start Time is required")
            return
        }

        if (offer?.endTime === 0) {
            toast.error("End Time is required")
            return
        }

        let body = {
            ...offer,
            startTime: moment(offer?.startTime).set({ hour: 0, minute: 0, second: 0, millisecond: 0 }).valueOf(),
            endTime: moment(offer?.endTime).set({ hour: 23, minute: 59, second: 59, millisecond: 59 }).valueOf()
        }

        if(edit){
            editOfferMutation.mutate({id: offer?.id, body: body})
        }else{
            addOfferMutation.mutate(body)
        }

    }

    useEffect(() => {
        if (props?.offer) {
            setOffer(props.offer)
            setEdit(true)
        } else {
            setOffer({
                name: "",
                banner: "",
                description: "",
                startTime: 0,
                endTime: 0,
                isActive: true
            })
            setEdit(false)
        }
    }, [])

    return (
        <Modal fullscreen show={props?.show} onHide={() => props?.close()}>
            <Modal.Header closeButton>
                <Modal.Title>Add Product</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form className="d-flex flex-column w-50 mx-auto">

                    <Form.Group className="mb-3">
                        <Form.Label>Name</Form.Label>
                        <Form.Control type="text" placeholder="Enter name" value={offer?.name} onChange={(e) => setOffer({ ...offer, name: e.target.value })} />
                    </Form.Group>

                    <Form.Group className="mb-3 d-flex align-items-center">
                        <Form.Label>Upload Banner: </Form.Label>
                        <button disabled={imageUploadMutation.isLoading} className="btn btn-primary mt-3 d-flex justify-content-center align-items-center" style={{ width: "50px", height: "50px", margin: "0.5rem", position: "relative" }}>
                            <i className="fas fa-upload"></i>
                            <input onClick={(e) => { e.target.value = null }} onChange={(e) => handleImageUpload(e)} type="file" style={{ width: "50px", height: "50px", position: "absolute", top: "0", left: "0", opacity: "0", cursor: "pointer" }} />
                        </button>

                        {(offer?.banner && offer?.banner !== "") && <div className="mt-3" style={{ width: "30px", height: "30px", margin: "0.5rem", position: "relative" }}>
                            <img
                                style={{ height: "100%", width: "100%" }}
                                className="d-block w-100"
                                src={offer?.banner}
                                alt="First slide"
                            />
                            <span onClick={() => {
                                setOffer({ ...offer, banner: "" })
                            }} className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                                <i style={{ cursor: "pointer" }} className="fas fa-times"></i>
                                <span className="visually-hidden">unread messages</span>
                            </span>
                        </div>}
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Start Time</Form.Label>
                        <Form.Control type="date" value={offer?.startTime} onChange={(e) => setOffer({ ...offer, startTime: e.target.value })} />
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>End Time</Form.Label>
                        <Form.Control type="date" value={offer?.endTime} onChange={(e) => setOffer({ ...offer, endTime: e.target.value })} />
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Is Active</Form.Label>
                        <Select
                            options={[
                                { value: true, label: "Yes" },
                                { value: false, label: "No" }
                            ]}
                            value={offer?.isActive ? { value: true, label: "Yes" } : { value: false, label: "No" }}
                            onChange={(e) => {
                                console.log(e)
                                if (e) {
                                    setOffer({ ...offer, isActive: e.value })
                                }
                            }}
                        />
                    </Form.Group>
                </Form>
            </Modal.Body>

            <Modal.Footer>
                <Button variant="secondary" onClick={() => props?.close()}>
                    Close
                </Button>
                <Button variant="primary" onClick={() => handleSubmit()}>
                    {edit ? "Edit" : "Add"}
                </Button>
            </Modal.Footer>
        </Modal>
    )
}